// eslint-disable-next-line import/prefer-default-export
export const homeTab = 'srtBookingHome';

export const STK_TICKET_DELIVERY = 'STK';
export const MVD_TICKET_DELIVERY = 'MVD';
